<template>
  <canvasjs v-bind="$props" :chartOptions="chartOptions" />
</template>

<script>
export default {
  name: 'dr-chart-canvas-editor',
  components: {
    canvasjs: () => import('./canvasjs.vue')
  },  
  props: {
    height: {
      require: false,
      type: String,
      default: '200px'
    },
    chartKey: {
      require: true,
      type: String
    }
  },
  data() {
    return {
      chart: null,
      chartOptions: {
        theme: 'light2',
        subtitles: [
          {
            text: 'Performance',
            fontStyle: 'bold',
            verticalAlign: 'center',
            dockInsidePlotArea: true
          },
          {
            text: 'Legend (On Hover)',
            fontStyle: 'bold',
            verticalAlign: 'top',
            horizontalAlign: 'right',
            dockInsidePlotArea: true
          }
        ],
        toolTip: {
          enabled: false
        },
        data: [
          {
            type: 'doughnut',
            indexLabel: '',
            mousemove: function (e) {
              // Update the subtitle
              e.chart.subtitles[0].set('text', e.dataPoint.label + ' (' + e.dataPoint.y + '%)')
              e.chart.subtitles[0].set('fontColor', e.dataPoint.color)

              // Update the legend
              e.chart.subtitles[1].set('text', e.dataPoint.legendLabel)
              e.chart.subtitles[1].set('fontColor', e.dataPoint.color)
            },
            showInLegend: false,
            dataPoints: [
              {
                y: 90,
                label: 'In Range',
                color: '#218340',
                legendLabel: '(Temp ≤ + 1°F)'
              },
              {
                y: 7,
                label: 'In Tolerance',
                color: '#F7B731',
                legendLabel: '(+ 1°F < Temp <= 2°F)'
              },
              {
                y: 3,
                label: 'Above Setpoint',
                color: '#A62337',
                legendLabel: '(Temp > + 2°F)'
              }
            ]
          }
        ]
      }
    }
  }
}
</script>

<style></style>
